// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"style__modalContainer___1iXUY","inner":"style__inner___3Z9kZ","title":"style__title___2EVis","subtitle":"style__subtitle___1WD0y","cloudLeft":"style__cloudLeft___Wv46t","cloudRight":"style__cloudRight___B-3lg","theme":"style__theme___3Uhnm","indicatorContainer":"style__indicatorContainer___1bVEZ","indicatorMock":"style__indicatorMock___1P5pn","indicator":"style__indicator___2Kv45"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/loader-generating/style.css
// module id = 1125
// module chunks = 0